// import React, {
// 	useCallback,
// 	useState,
// 	useRef,
// 	useEffect
// } from 'react'

// import debounce from 'lodash/debounce'
// import { fetchPatientsList } from '../../services/actions/patients/patientsList'
// import { useCustomPatientSelectors } from '../../services/selectors/patientSelectors'

// import { fetchAllClinics } from '../../services/actions/pharmacy/clinic/getClinics'
// import { fetchAllPharmacyLists } from '../../services/actions/pharmacy/forms/pharmacyList'
// import { removeWorkSpaceTab } from '../../utils/helper/helper'
// import { useFormsSelectors } from '../../services/selectors/formsSelector'
// import { TopHeaderSearchStyle } from '../../style'

// import { AddNotes } from '../../models/patients'
// import { useCustomLoadingStates } from '../../hooks/customStates'
// import { openPatientNoteModal } from '../../assets/js/custome'
// import { ErrorToastMessage, SuccessToastMessage } from '../loaders/toastMessage'
// import { patientNotesListFailure, patientNotesListSuccess } from '../../services/actions/patients/patientNotesList'

// import isEqual from 'lodash/isEqual';
// import Select from 'react-select'

// import * as Icons from '../../assets/svg/icons'
// import * as Hooks from '../../hooks'
// import * as routesNames from '../../routes/routeName'
// import * as useEffectHelper from '../../utils/helper/useEffectsHelper'
// import SearchInput from './searchInput'

// export const SearchBar = () => {

// 	const inputRef = useRef(null);
// 	const searchContainerRef = useRef(null);

// 	const location = Hooks.useCustomLocation()
// 	const navigate = Hooks.useCustomNavigate()
// 	const dispatch = Hooks.useCustomDispatch()

// 	const [searchValue, setSearchValue] = useState('')
// 	const [data, setData] = useState([]);
// 	const [selectedOptions, setSelectedOptions] = useState()
// 	const [showList, setShowList] = useState(true);

// 	const { getClinicsData,
// 		getAllClinicsResponse } = useCustomPatientSelectors()

// 	const { pharmaciesListResponse } = useFormsSelectors()

// 	const {
// 		showToast, setShowToast,
// 		showModal, setShowModal
// 	} = useCustomLoadingStates()

// 	// Handle click outside dropdown
// 	useEffect(() => {
// 		const handleClickOutside = (event) => {
// 			if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
// 				setShowList(false);
// 			}
// 		};

// 		// Add event listener when dropdown is shown
// 		if (showList && (selectedOptions?.label === 'Clinic' || selectedOptions?.label === 'Pharmacy') && searchValue.length >= 3) {
// 			document.addEventListener('mousedown', handleClickOutside);
// 		}

// 		// Cleanup event listener
// 		return () => {
// 			document.removeEventListener('mousedown', handleClickOutside);
// 		};
// 	}, [showList, selectedOptions, searchValue]);

// 	const handleInputChange = useCallback(
// 		debounce((e) => {
// 			e.preventDefault()
// 			const search = e.target.value;
// 			setShowList(true)
// 			setSearchValue(search)
// 			const queryStatus = new URLSearchParams(location.search).get('status');
// 			const page = search ? '' : parseInt(new URLSearchParams(location.search).get('page')) || 1;

// 			const searchParams = new URLSearchParams();

// 			if (queryStatus !== null) {
// 				searchParams.append('status', queryStatus);
// 			}

// 			if (page !== '') {
// 				searchParams.append('page', page);
// 			}

// 			if (search) {
// 				searchParams.append('search', search);
// 			}

// 			if (selectedOptions?.label === 'Patient') {
// 				const newUrl = `${routesNames.ALL_PATIENTS}?${searchParams.toString()}`;
// 				navigate(newUrl)
// 				sessionStorage.setItem('work_tab', 0)
// 				dispatch(fetchPatientsList(search, queryStatus, page));
// 			}

// 			if (selectedOptions?.label === 'Clinic' && search.length >= 3) {
// 				dispatch(fetchAllClinics(search))
// 				removeWorkSpaceTab()
// 			}

// 			if (selectedOptions?.label === 'Pharmacy' && search.length >= 3) {
// 				dispatch(fetchAllPharmacyLists(search))
// 				removeWorkSpaceTab()
// 			}

// 		}, 1000),
// 		[dispatch, location.search, navigate])

// 	useEffectHelper.useTopHeaderSearchEffect(inputRef, data, setSelectedOptions, setData)

// 	return (<>
// 		<div className="Oat_HeaderSeachBg flex gap-1 relative" ref={searchContainerRef}>
// 			{/* <div className='flex'>

// 				<Select
// 					isClearable={false}
// 					isSearchable={false}
// 					className="basic-multi-select z-50  font-medium rounded-sm text-sm   items-center xl:inline-flex hidden"
// 					classNamePrefix="react-select"
// 					placeholder='Pharmacy'
// 					options={data}
// 					value={selectedOptions}
// 					onChange={(selectedValues) => {
// 						if (!isEqual(selectedValues, selectedOptions)) {
// 							setSelectedOptions(selectedValues);
// 						}
// 					}}
// 					styles={TopHeaderSearchStyle} />

// 				<input className="shadow appearance-none border-l-transparent h-12 fs-18 rubik-400 rounded-lg w-64	 
// 									  text-gray-700 rounded-l-none leading-tight focus:outline-none focus:shadow-outline 
// 									!focus:border-transparent focus:ring-transparent xl:inline-flex hidden"
// 					style={{ borderLeft: '0px solid white' }}

// 					type="text"
// 					ref={inputRef}
// 					placeholder="Search"
// 					onChange={handleInputChange} />
// 			</div> */}

// 			<SearchInput />

// 			<button onClick={() => {
// 				return (openPatientNoteModal(setShowModal, showModal),
// 					dispatch(patientNotesListFailure(null, null)),
// 					dispatch(patientNotesListSuccess(null, null)))
// 			}} className="h-12 min-w-28 rounded-lg text-white font-medium bg-[#4E64C2] text-sm px-5 py-2.5 
// 			text-center lg:inline-flex hidden items-center justify-center" type="button">Add Note
// 			</button>

// 			<button onClick={() => { return removeWorkSpaceTab(), navigate(routesNames.pharmacy_juno_appointment) }}
// 				 className="min-w-28 rounded-lg   bg-[#4E64C2] text-white font-medium  
// 				 text-sm px-5 py-2.5 text-center  items-center justify-center md:hidden lg:hidden xl:flex sm:flex flex" type="button">
// 				Appointments
// 			</button>

// 			{/* <LabelToMargin  /> */}

// 			{selectedOptions?.label === 'Clinic' && searchValue.length >= 3 && showList &&
// 				<div className="z-30 absolute top-10 mt-2 w-64 bg-white border border-gray-300 rounded"
// 					style={{ left: '110px', maxHeight: '200px', overflowY: 'auto' }}>
// 					{getAllClinicsResponse?.loading ?
// 						<div className="p-2 cursor-pointer">Searching...</div>
// 						:
// 						getClinicsData?.length === 0 ?
// 							<div className="p-2 cursor-pointer">No Result Found</div>
// 							:
// 							getAllClinicsResponse?.error !== null ?
// 								<div className="p-2 cursor-pointer">Some Error Occurred. Please search again.</div>
// 								:
// 								<div>
// 									{getClinicsData?.map((value, index) => (
// 										<React.Fragment key={index}>
// 											<div onClick={() => { return navigate(`${routesNames.pharmacy_search_module}?module=clinic&id=${value.id}`), setShowList(false) }} className="p-2 cursor-pointer">
// 												<p className='fs-14 rubik-400'>{value.name}</p>
// 												<p className='fs-12 pl-2 flex'><Icons.PhoneCallIcon /> {value?.phone}</p>
// 											</div>
// 										</React.Fragment>
// 									))}
// 								</div>
// 					}
// 				</div>
// 			}

// 			{selectedOptions?.label === 'Pharmacy' && searchValue.length >= 3 && showList &&
// 				<div className="z-30 absolute top-10 mt-2  w-64 bg-white border border-gray-300 rounded-md"
// 					style={{ left: '110px', maxHeight: '200px', overflowY: 'auto' }}>
// 					{pharmaciesListResponse?.loading ?
// 						<div className="p-2 cursor-pointer">Searching...</div>
// 						:
// 						pharmaciesListResponse?.data?.data?.length === 0 ?
// 							<div className="p-2 cursor-pointer">No Result Found</div>
// 							:
// 							pharmaciesListResponse?.error !== null ?
// 								<div className="p-2 cursor-pointer">Some Error Occurred. Please search again.</div>
// 								:
// 								<div>
// 									{pharmaciesListResponse?.data?.data?.map((value, index) => (
// 										<React.Fragment key={index}>
// 											<div onClick={() => { return navigate(`${routesNames.pharmacy_search_module}?module=pharmacies&id=${value.id}`), setShowList(false) }} className="p-2 cursor-pointer ">
// 												<p className='fs-14 rubik-400'>{value.name}</p>
// 												<p className='fs-12 pl-2 flex'>
// 													<Icons.PhoneCallIcon />
// 													{value?.phone}</p>
// 											</div>
// 										</React.Fragment>
// 									))}
// 								</div>
// 					}
// 				</div>
// 			}
// 		</div>

// 		{
// 			showModal.patientNoteModal &&
// 			<AddNotes
// 				showToast={showToast}
// 				setShowToast={setShowToast}
// 				setShowModal={setShowModal}
// 				showModal={showModal}
// 				type='Header_Add_Note'
// 			/>
// 		}

// 		{
// 			showToast?.patientNoteToast &&
// 			<SuccessToastMessage status='Note added sucessfully' />
// 		}


// 		{
// 			showToast?.patientNoteToastError &&
// 			<ErrorToastMessage />
// 		}

// 	</>
// 	)
// }




import React, {
	// useCallback,
	useState,
	useRef,
	useEffect
} from 'react'

// import debounce from 'lodash/debounce'
// import { fetchPatientsList } from '../../services/actions/patients/patientsList'
import { useCustomPatientSelectors } from '../../services/selectors/patientSelectors'
import { useCustomSelectors } from '../../services/selectors/allSelectors'

// import { fetchAllClinics } from '../../services/actions/pharmacy/clinic/getClinics'
// import { fetchAllPharmacyLists } from '../../services/actions/pharmacy/forms/pharmacyList'
import { removeWorkSpaceTab } from '../../utils/helper/helper'
import { useFormsSelectors } from '../../services/selectors/formsSelector'
// import { TopHeaderSearchStyle } from '../../style'

import { AddNotes } from '../../models/patients'
import { useCustomLoadingStates } from '../../hooks/customStates'
// import { openPatientNoteModal } from '../../assets/js/custome'
import { ErrorToastMessage, SuccessToastMessage } from '../loaders/toastMessage'
// import { patientNotesListFailure, patientNotesListSuccess } from '../../services/actions/patients/patientNotesList'

// import isEqual from 'lodash/isEqual';
// import Select from 'react-select'

import * as Icons from '../../assets/svg/icons'
// import { PrintIcons } from '../../assets/svg/icons'
import * as images from "../../assets/images/index";

import * as Hooks from '../../hooks'
import * as routesNames from '../../routes/routeName'
import * as useEffectHelper from '../../utils/helper/useEffectsHelper'
import SearchInput from './searchInput'
import PrintSingleRxButton from './PrintSingleRxButton'
import {
	SAFE_SUPPLY_IV_CODE_COUNT_EVENT,
	SAFE_SUPPLY_IV_CODE_OPEN_EVENT,
} from '../pharmacy/dispense/safeSupplyIvCodeReviewEvents'
import {
	MISMATCH_SCHEDULE_COUNT_EVENT,
	MISMATCH_SCHEDULE_OPEN_EVENT,
	canViewMismatchScheduleReview,
} from '../pharmacy/dispense/mismatchScheduleReviewEvents'

export const SearchBar = () => {

	const inputRef = useRef(null);
	const searchContainerRef = useRef(null);

	const location = Hooks.useCustomLocation()
	const navigate = Hooks.useCustomNavigate()
	const dispatch = Hooks.useCustomDispatch()

	const [searchValue, setSearchValue] = useState('')
	const [data, setData] = useState([]);
	const [selectedOptions, setSelectedOptions] = useState()
	const [showList, setShowList] = useState(true);
	const [missingIvCodeCount, setMissingIvCodeCount] = useState(() => Number(window.__oatrxSafeSupplyIvCodeCount || 0));
	const [hasViewedMissingIvCodes, setHasViewedMissingIvCodes] = useState(false);
	const [mismatchScheduleCount, setMismatchScheduleCount] = useState(() => Number(window.__oatrxMismatchScheduleCount || 0));
	const [hasViewedMismatchSchedules, setHasViewedMismatchSchedules] = useState(false);

	const { getClinicsData,
		getAllClinicsResponse } = useCustomPatientSelectors()

	const { pharmaciesListResponse } = useFormsSelectors()
	const { emrStatus, profileData } = useCustomSelectors()
	const canViewMismatchSchedule = canViewMismatchScheduleReview({ profileData })

	const {
		showToast, setShowToast,
		showModal, setShowModal
	} = useCustomLoadingStates()

	// Handle click outside dropdown
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
				setShowList(false);
			}
		};

		// Add event listener when dropdown is shown
		if (showList && (selectedOptions?.label === 'Clinic' || selectedOptions?.label === 'Pharmacy') && searchValue.length >= 3) {
			document.addEventListener('mousedown', handleClickOutside);
		}

		// Cleanup event listener
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [showList, selectedOptions, searchValue]);

	// const handleInputChange = useCallback(
	// 	debounce((e) => {
	// 		e.preventDefault()
	// 		const search = e.target.value;
	// 		setShowList(true)
	// 		setSearchValue(search)
	// 		const queryStatus = new URLSearchParams(location.search).get('status');
	// 		const page = search ? '' : parseInt(new URLSearchParams(location.search).get('page')) || 1;

	// 		const searchParams = new URLSearchParams();

	// 		if (queryStatus !== null) {
	// 			searchParams.append('status', queryStatus);
	// 		}

	// 		if (page !== '') {
	// 			searchParams.append('page', page);
	// 		}

	// 		if (search) {
	// 			searchParams.append('search', search);
	// 		}

	// 		if (selectedOptions?.label === 'Patient') {
	// 			const newUrl = `${routesNames.ALL_PATIENTS}?${searchParams.toString()}`;
	// 			navigate(newUrl)
	// 			sessionStorage.setItem('work_tab', 0)
	// 			dispatch(fetchPatientsList(search, queryStatus, page));
	// 		}

	// 		if (selectedOptions?.label === 'Clinic' && search.length >= 3) {
	// 			dispatch(fetchAllClinics(search))
	// 			removeWorkSpaceTab()
	// 		}

	// 		if (selectedOptions?.label === 'Pharmacy' && search.length >= 3) {
	// 			dispatch(fetchAllPharmacyLists(search))
	// 			removeWorkSpaceTab()
	// 		}

	// 	}, 1000),
	// 	[dispatch, location.search, navigate])

	useEffectHelper.useTopHeaderSearchEffect(inputRef, data, setSelectedOptions, setData)

	useEffect(() => {
		const handleMissingIvCodeCount = (event) => {
			const nextCount = Number(event?.detail?.count || 0)
			setMissingIvCodeCount((previousCount) => {
				if (nextCount !== previousCount) {
					setHasViewedMissingIvCodes(false)
				}

				return nextCount
			})
		}

		window.addEventListener(SAFE_SUPPLY_IV_CODE_COUNT_EVENT, handleMissingIvCodeCount)

		return () => {
			window.removeEventListener(SAFE_SUPPLY_IV_CODE_COUNT_EVENT, handleMissingIvCodeCount)
		}
	}, [])

	useEffect(() => {
		const handleMismatchScheduleCount = (event) => {
			const nextCount = Number(event?.detail?.count || 0)
			setMismatchScheduleCount((previousCount) => {
				if (nextCount !== previousCount) {
					setHasViewedMismatchSchedules(false)
				}

				return nextCount
			})
		}

		window.addEventListener(MISMATCH_SCHEDULE_COUNT_EVENT, handleMismatchScheduleCount)

		return () => {
			window.removeEventListener(MISMATCH_SCHEDULE_COUNT_EVENT, handleMismatchScheduleCount)
		}
	}, [])

	const handleOpenMissingIvCodes = () => {
		setHasViewedMissingIvCodes(true)
		window.dispatchEvent(new CustomEvent(SAFE_SUPPLY_IV_CODE_OPEN_EVENT))
	}

	const handleOpenMismatchSchedules = () => {
		setHasViewedMismatchSchedules(true)
		window.dispatchEvent(new CustomEvent(MISMATCH_SCHEDULE_OPEN_EVENT))
	}

	return (<>
		<div className="Oat_HeaderSeachBg flex flex-wrap gap-2 relative  min-w-[820px] " ref={searchContainerRef}>
			{/* <div className='flex'>

				<Select
					isClearable={false}
					isSearchable={false}
					className="basic-multi-select z-50  font-medium rounded-sm text-sm   items-center xl:inline-flex hidden"
					classNamePrefix="react-select"
					placeholder='Pharmacy'
					options={data}
					value={selectedOptions}
					onChange={(selectedValues) => {
						if (!isEqual(selectedValues, selectedOptions)) {
							setSelectedOptions(selectedValues);
						}
					}}
					styles={TopHeaderSearchStyle} />

				<input className="shadow appearance-none border-l-transparent h-12 fs-18 rubik-400 rounded-lg w-64	 
									  text-gray-700 rounded-l-none leading-tight focus:outline-none focus:shadow-outline 
									!focus:border-transparent focus:ring-transparent xl:inline-flex hidden"
					style={{ borderLeft: '0px solid white' }}

					type="text"
					ref={inputRef}
					placeholder="Search"
					onChange={handleInputChange} />
			</div> */}

			<img
				src={images.oatrx_logoWhite}
				className="text-left btnnn"
				alt=""
				onClick={() => {
					navigate("/dashboard")
					removeWorkSpaceTab()
				}}
			/>

			<SearchInput />

			<PrintSingleRxButton />
			<div id="pharmacist-driver-call-header-action" className="md:flex hidden" />

			{profileData?.type === 'pharmacist' && missingIvCodeCount > 0 ? (
				<button
					type="button"
					onClick={handleOpenMissingIvCodes}
					style={{
						backgroundColor: hasViewedMissingIvCodes ? '#FDE047' : '#FACC15',
						color: '#422006',
						borderColor: '#CA8A04',
					}}
					className={`h-12 min-w-[56px] rounded-lg px-4 py-2.5 text-sm font-semibold transition-colors md:flex hidden items-center justify-center border hover:brightness-105 ${
						hasViewedMissingIvCodes ? '' : 'animate-pulse shadow-sm'
					}`}
					title="Safe Supply prescriptions missing IV code — click to review"
				>
					IV ({missingIvCodeCount})
				</button>
			) : null}

			{canViewMismatchSchedule && mismatchScheduleCount > 0 ? (
				<button
					type="button"
					onClick={handleOpenMismatchSchedules}
					style={{
						backgroundColor: '#F59E0B',
						color: '#FFFFFF',
						borderColor: '#D97706',
					}}
					className={`h-12 min-w-[156px] rounded-lg px-4 py-2.5 text-sm font-semibold transition-colors md:flex hidden items-center justify-center gap-2 border hover:brightness-105 ${
						hasViewedMismatchSchedules ? '' : 'animate-pulse shadow-sm'
					}`}
					title="Schedule-dose mismatches between WinRx and OatRx/REC - click to review"
				>
					<span>Mismatch Schedule</span>
					<span className="inline-flex min-w-6 items-center justify-center rounded-full bg-[#DC2626] px-2 py-0.5 text-xs font-bold text-white">
						{mismatchScheduleCount}
					</span>
				</button>
			) : null}

			{/* {location.pathname !== '/dashboard' && (
				<button onClick={() => {
					return (openPatientNoteModal(setShowModal, showModal),
						dispatch(patientNotesListFailure(null, null)),
						dispatch(patientNotesListSuccess(null, null)))
				}} className="h-12 min-w-28 rounded-lg text-white font-medium bg-[#4E64C2] text-sm px-3 py-2.5 
				text-center  items-center justify-center md:flex hidden" type="button">Add Note
				</button>
			)} */}

			{emrStatus === 1 && (
				<button onClick={() => { return removeWorkSpaceTab(), navigate(routesNames.pharmacy_juno_appointment) }}
					className="min-w-28 rounded-lg   bg-[#4E64C2] text-white font-medium  
					 text-sm px-3 py-2.5 text-center  items-center justify-center md:flex hidden" type="button">
					Appointments
				</button>
			)}

			{/* <LabelToMargin  /> */}

			{selectedOptions?.label === 'Clinic' && searchValue.length >= 3 && showList &&
				<div className="z-30 absolute top-10 mt-2 w-64 bg-white border border-gray-300 rounded"
					style={{ left: '110px', maxHeight: '200px', overflowY: 'auto' }}>
					{getAllClinicsResponse?.loading ?
						<div className="p-2 cursor-pointer">Searching...</div>
						:
						getClinicsData?.length === 0 ?
							<div className="p-2 cursor-pointer">No Result Found</div>
							:
							getAllClinicsResponse?.error !== null ?
								<div className="p-2 cursor-pointer">Some Error Occurred. Please search again.</div>
								:
								<div>
									{getClinicsData?.map((value, index) => (
										<React.Fragment key={index}>
											<div onClick={() => { return navigate(`${routesNames.pharmacy_search_module}?module=clinic&id=${value.id}`), setShowList(false) }} className="p-2 cursor-pointer">
												<p className='fs-14 rubik-400'>{value.name}</p>
												<p className='fs-12 pl-2 flex'><Icons.PhoneCallIcon /> {value?.phone}</p>
											</div>
										</React.Fragment>
									))}
								</div>
					}
				</div>
			}

			{selectedOptions?.label === 'Pharmacy' && searchValue.length >= 3 && showList &&
				<div className="z-30 absolute top-10 mt-2  w-64 bg-white border border-gray-300 rounded-md"
					style={{ left: '110px', maxHeight: '200px', overflowY: 'auto' }}>
					{pharmaciesListResponse?.loading ?
						<div className="p-2 cursor-pointer">Searching...</div>
						:
						pharmaciesListResponse?.data?.data?.length === 0 ?
							<div className="p-2 cursor-pointer">No Result Found</div>
							:
							pharmaciesListResponse?.error !== null ?
								<div className="p-2 cursor-pointer">Some Error Occurred. Please search again.</div>
								:
								<div>
									{pharmaciesListResponse?.data?.data?.map((value, index) => (
										<React.Fragment key={index}>
											<div onClick={() => { return navigate(`${routesNames.pharmacy_search_module}?module=pharmacies&id=${value.id}`), setShowList(false) }} className="p-2 cursor-pointer ">
												<p className='fs-14 rubik-400'>{value.name}</p>
												<p className='fs-12 pl-2 flex'>
													<Icons.PhoneCallIcon />
													{value?.phone}</p>
											</div>
										</React.Fragment>
									))}
								</div>
					}
				</div>
			}
		</div>

		{
			showModal.patientNoteModal &&
			<AddNotes
				showToast={showToast}
				setShowToast={setShowToast}
				setShowModal={setShowModal}
				showModal={showModal}
				type='Header_Add_Note'
			/>
		}

		{
			showToast?.patientNoteToast &&
			<SuccessToastMessage status='Note added sucessfully' />
		}


		{
			showToast?.patientNoteToastError &&
			<ErrorToastMessage />
		}

	</>
	)
}


